// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/shopping-cart.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/shopping-cart'

import { Icon, type IconComponentProps } from '../icon'

export const ShoppingCartIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
